module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Shuffle-e5fbeda8df2ba1868b46b327a22d42d5.svg";